module.exports = __webpack_public_path__ + "img/safe_tool_1.9467e7a8.jpg";